module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageSize":"Page size","view":"View","of":"of"},"hr":{"pageSize":"Veličina stranice","view":"Prikazuje se","of":"od"}}')
  delete Component.options._Ctor
}
